import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TdoOrganizerCategorizeModel} from './models/tdo-organizer-categorize.model';
import {Globals} from '../../../../globals';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {DocumentTagDataModel} from '../../../../models/document/document-tag-data.model';
import {DocumentDataModel} from '../../../../models/document/document-data.model';
import {FileManagerService} from '../../../../modules/file-manager/file-manager.service';
import { DOC_TAG_PATIENT_PIC } from 'src/app/constants';
import { AuthenticationService } from 'src/app/modules/auth/services/authentication.service';
import { SignalrService } from 'src/app/services/socket/signalr.service';

class TagsToRemove {
  doc: DocumentDataModel;
  tags: DocumentTagDataModel[] = [];
}

@Component({
  selector: 'app-tdo-organizer-categorize-dialog',
  templateUrl: './tdo-organizer-categorize-dialog.component.html',
  styleUrls: ['./tdo-organizer-categorize-dialog.component.scss']
})
export class TdoOrganizerCategorizeDialogComponent implements OnInit {
  dataModel: TdoOrganizerCategorizeModel;
  basePath: string;

  tagsToAdd: EnumValidValueItemModel[] = [];
  tagsToRemove: TagsToRemove[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) data, public dialogRef: MatDialogRef<TdoOrganizerCategorizeDialogComponent>, 
  private fileService: FileManagerService,
  public globals: Globals, 
  private authServer: AuthenticationService,
  private signalrService: SignalrService,) {
    this.dataModel = data as TdoOrganizerCategorizeModel;
  }

  ngOnInit(): void {
  }

  onCheckboxChange(event: MatCheckboxChange, option: EnumValidValueItemModel) {
    if (this.tagsToAdd.includes(option)) {
      const idx = this.tagsToAdd.findIndex(p => p === option);
      if (idx > -1) {
        this.tagsToAdd.splice(idx, 1);
      }
    } else {
      this.tagsToAdd.push(option);
    }
  }

  onApply() {
    if (this.tagsToRemove.length > 0) {
      for (const doc of this.tagsToRemove) {
        this.fileService.removeDocumentTags(doc.doc.DocumentID , doc.tags.map(p => p.DocumentTagID)).subscribe((res) => {
          if(doc.tags.map(x=> x.enumDocumentTagID.toUpperCase()).includes(DOC_TAG_PATIENT_PIC)) {
            this.globals.ThePatient.patientImageUrl = '';
            this.globals.save();
            this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, 'UPDATE_PATIENT_PICTURE', {patientId: this.globals.currentPatientId});
          }

          doc.doc.dataDocumentTags.filter(p => !doc.tags.map(e => e.DocumentTagID).includes(p.DocumentTagID));
        }, error => {
          //
        });
      }
    }

    const tagsEnums = this.tagsToAdd.map(p => p.ValidValueItemId);
    this.dialogRef.close(tagsEnums);
  }

  onCancel() {
    if (this.tagsToRemove && this.tagsToRemove.length > 0) {
      for (const ttr of this.tagsToRemove) {
        if (ttr.doc.dataDocumentTags) {
          const orig = this.dataModel.documents.find(p => p.DocumentID === ttr.doc.DocumentID);
          if (orig) {
            orig.dataDocumentTags.push(... ttr.tags);
          }
        }
      }
    }

    this.dialogRef.close(null);
  }

  get isAnyNewTags() {
    return this.tagsToAdd.length === 0 && this.tagsToRemove.length === 0;
  }

  onDeleteDocumentTag(doc: DocumentDataModel, tag: DocumentTagDataModel) {
    let tagToRemove = this.tagsToRemove.find(p => p.doc.DocumentID === doc.DocumentID);
    if (tagToRemove) {
      tagToRemove.tags.push(tag);
    } else {
      tagToRemove = new TagsToRemove();
      tagToRemove.doc = doc;
      tagToRemove.tags.push(tag);
      this.tagsToRemove.push(tagToRemove);
    }
    const idx = doc.dataDocumentTags.findIndex(p => p === tag);
    if (idx > -1) {
      doc.dataDocumentTags.splice(idx, 1);
    }
    /*this.fileService.removeDocumentTags(doc.DocumentID , [tag.DocumentTagID]).subscribe((res) => {
      const idx = doc.dataDocumentTags.findIndex(p => p === tag);
      if (idx > -1) {
        doc.dataDocumentTags.splice(idx, 1);
      }
    }, error => {
      //
    });*/
  }

  getDocumentUrl(doc: DocumentDataModel) {
    return this.fileService.getDocumentUrlFromDocument(doc);
  }

  onTagsAdded(event: EnumValidValueItemModel[]) {
    this.tagsToAdd = event;
  }
}
